import React from "react"
import s from '../PortfolioCards/workcard.module.scss'
const PortfolioCards = (props) => {
  return (
    <div className={s.wrapper} key={props.id}>
      <h3 className={s.title}>{props.title}</h3>
      <a
        className={s.imageWrapper}
        href={props.siteLink}
        target='_blank'
        rel='noopener noreferrer'
      >
        <img src={props.img} alt='' className={s.image} />
      </a>
      <div className={s.description}>
        <p className={s.descript}>
          <span>Project Description : </span>
          {props.description}
        </p>
        {/* <p className={s.problemsAndSolves}>
            <span> Problems and Solves : </span>
            {props.problemsAndSolves}{" "}
          </p> */}
        <span className={s.stack}>
          <span>Stack:</span>
          {props.stack}
        </span>
        <a
          className={s.github}
          href={props.github}
          target='_blank'
          rel='noopener noreferrer'
        >
          <span className={s.githubText}>Source Code</span>
        </a>
      </div>
    </div>
  )
}

export default PortfolioCards
